module.exports = __webpack_public_path__ + "img/conferences.0ec795d5.png";